import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useMutation, useQueryClient } from 'react-query';
import { useModal } from 'store/modals';
import { LAUNDRY_BOOKINGS } from '../bookings/hook';
import { deleteBookingAPI } from './api';

export function useDeleteBooking({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, isLoading, isSuccess, isError, error } = useMutation(
    (bookingId) => deleteBookingAPI(bookingId),
    {
      onSuccess: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'deleteBookingSuccess',
          },
        });
        queryClient.invalidateQueries([LAUNDRY_BOOKINGS, tenantId]);
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'deleteBookingFail',
          },
        });
      },
    },
  );

  return {
    deleteBooking: mutate,
    isSuccess,
    isLoading,
    isError,
    error: error && error.message,
  };
}

